import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/testimonial`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchTestimonials = (payload) => apiHelper(API_URL, 'GET', payload);
export const createTestimonial = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchTestimonial = (testimonialId) => apiHelper(`${API_URL}/${testimonialId}`, 'GET');
export const modifyTestimonial = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteTestimonialApi = (testimonialId) => apiHelper(`${API_URL}/${testimonialId}`, 'DELETE');
export const changeStatus = (testimonialId) => apiHelper(`${API_URL}/change-status/${testimonialId}`, 'POST');

